import React, { Component } from "react";
import { connect } from "react-redux";

import Sidebar from "../../Components/Sidebar";
import Btn from "../../Components/Btn";
import CustomersTable from "./Components/CustomersTable";
import { bindActionCreators } from "redux";
import { searchCustomers, setVariable } from "../../store/customers/actions";
import Searchbar from '../../Components/Searchbar';
import { loaderstyle } from '../../config';
import LoadingOverlay from 'react-loading-overlay';

class Customers extends Component {
  state = {
    syncActive: false
  };

  componentDidMount() {
    // search for customers.
    this.props.searchCustomers({ resetPage: true });
  }

  toggleSyncClasses = () => {
    this.setState({ syncActive: !this.state.syncActive });
    setTimeout(() => {
      this.setState({ syncActive: false });
    }, 3000);
  };

  setVariable = e => {
    this.props.setVariable(e.target.value);
  };

  render() {
    let syncClasses = this.state.syncActive ? "overlay_visible" : "";
    return (
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading">
              <h1>Customers: {this.props.total_customers}</h1>
              {/* <Btn className="btn simple" onClick={(event) => { event.preventDefault(); this.toggleSyncClasses() }}><img src="/imgs/icons/sync.png" alt="sync icon" width="12"/>sync</Btn> */}
              <div className={`overlay overlay-sync ${syncClasses}`}>
                <p>Syncing Customers …</p>
              </div>
            </div>
            <div className="page-title-actions">
              <form action="#">
                <Searchbar
                  label="Search"
                  placeholder="Customer ID, Name, Email, Phone"
                  value={this.props.variable}
                  onChange={this.setVariable}/>
                
                <div className="form-field">
                  <Btn className="btn simple small">Search</Btn>
                </div>
              </form>
            </div>
          </div>
            <LoadingOverlay
              active={this.props.loading}
              text="Loading..."
              spinner
              styles={loaderstyle}>
            <CustomersTable />
          </LoadingOverlay>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  customers: state.customers.customers,
  loading: state.customers.loading,
  variable: state.customers.searchOptions.variable,
  total_customers: state.customers.total_customers
});

const mapDispatchToProps = dispatch => ({
  searchCustomers: bindActionCreators(searchCustomers, dispatch),
  setVariable: bindActionCreators(setVariable, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Customers);
